import { observer, useLocalObservable } from "mobx-react";
import { Modal, Spin, Button, Popconfirm, Table, Tag } from "antd";
import { translateKey as t } from "../../../../../../locales/translation";
import { ClientsController } from "../../../ClientsController";
import { AppStore } from "~/stores/AppStore";
import { useEffect } from "react";
import dayjs from "dayjs";
import _ from "lodash";

const DeleteScenarioSnapshotModal = observer(({ store, controller }: { store?: AppStore; controller?: ClientsController }) => {
  useEffect(() => {});
  const localStore = useLocalObservable(() => ({
    errorMessage: "",

    setError(message) {
      this.errorMessage = message;
    },
  }));

  const { visible, loading, spinMessage } = controller.deleteScenarioSnapshotModal;

  const handleOk = async (scenarioId) => {
    console.log(scenarioId);
    try {
      controller.setDeleteScenarioSnapshotModal("loading", true);
      await controller.deleteScenarioSnapshot(scenarioId);
      await controller.loadScenarioSnapshots();
      // handleClose();
    } catch (error) {
      localStore.setError(error.message);
    } finally {
      controller.setDeleteScenarioSnapshotModal("loading", false);
    }
  };

  const handleClose = () => {
    localStore.setError("");
    controller.setDeleteScenarioSnapshotModal(null, {
      visible: false,
      loading: false,
      spinMessage: "",
    });

    controller.setDepots([]);
    controller.setScenarioSnapshots([]);
  };

  const renderTable = () => {
    const { scenarioSnapshots, formatText } = controller;
    const columns = [
      {
        title: "Reference",
        dataIndex: "ref",
        key: "ref",
      },
      {
        title: "Type",
        dataIndex: "type",
        key: "type",
        render: (text, data) => {
          return data?.type ? <Tag color="blue">{formatText(data.type)}</Tag> : null;
        },
      },
      {
        title: "Client",
        dataIndex: "client",
        key: "client",
      },
      {
        title: "Depot",
        dataIndex: "depotName",
        key: "depotName",
        render: (text, data) => (data?.depot?.name ? data.depot.name : null),
      },
      {
        title: "Date",
        dataIndex: "date",
        key: "date",
        render: (text) => dayjs(text).format("YYYY-MM-DD"),
      },
      {
        title: "Created By",
        dataIndex: "createdBy",
        key: "createdBy",
      },
      {
        title: "Created At",
        dataIndex: "createdAt",
        key: "createdAt",
        render: (text) => dayjs(text).format("YYYY-MM-DD HH:mm"),
      },
      {
        title: "Delete",
        dataIndex: "_id",
        key: "delete",
        render: (scenarioId) => {
          return (
            <Popconfirm
              placement="topRight"
              key="ok"
              title="Are you sure you want to delete scenario snapshot?"
              onConfirm={() => handleOk(scenarioId)}
              okText="Proceed"
              cancelText="Cancel"
              overlayStyle={{ width: 300 }}
            >
              <Button type="primary" danger>
                {t("lblDelete", "Delete")}
              </Button>
            </Popconfirm>
          );
        },
      },
    ];

    return (
      <Table
        columns={columns}
        loading={{
          spinning: loading,
          tip: spinMessage,
          size: "default",
        }}
        // loading={<Spin size="large" spinning={loading} tip={spinMessage}/>}
        dataSource={scenarioSnapshots.map((item) => ({ ...item, key: item._id }))}
        pagination={false}
      />
    );
  };

  if (!visible) {
    return null;
  }

  return (
    <Modal
      title="Scenario Snapshots"
      styles={{
        header: { borderBottom: "1px solid #0505050f", paddingBottom: 10 },
      }}
      open={visible}
      onCancel={handleClose}
      centered
      maskClosable={false}
      footer={[
        <Button key="close" onClick={handleClose}>
          {t("lblClose", "Close")}
        </Button>,
      ]}
      width={"75%"}
    >
      {renderTable()}
    </Modal>
  );
});

export default DeleteScenarioSnapshotModal;
